import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Sidebar extends Component {
  render() {
    return (
        <nav className="w3-sidebar w3-collapse w3-white w3-animate-left" style={{zIndex:'3',width:'300px'}} id="mySidebar"><br />
            <div className="w3-container w3-row">
                <div className="w3-col s4">
                    <img src="https://www.w3schools.com/w3images/avatar2.png" alt='' className="w3-circle w3-margin-right" style={{width:'46px'}} />
                </div>
                <div className="w3-col s8 w3-bar">
                    <span>Welcome, <strong>Usuario</strong></span><br />
                    <Link to={`/correos`} className="w3-bar-item w3-button"><i className="far fa-envelope"></i></Link>
                    <Link to={`/usuario`} className="w3-bar-item w3-button"><i className="far fa-user-circle"></i></Link>
                    <Link to={`/config`} className="w3-bar-item w3-button"><i className="fas fa-cog"></i></Link>
                </div>
            </div>
            <hr />
            <div className="w3-container">
                <h5>Dashboard</h5>
            </div>
            <div className="w3-bar-block">
                    <a href="" className="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" title="close menu"><i className="fa fa-remove fa-fw"></i>  Close Menu</a>
                    <Link to={`/`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-home"></i>  Home</Link>
                    <Link to={`/clientes`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-users"></i>  Clientes</Link>
                    <Link to={`/pedidos`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-shopping-cart"></i>  Pedidos</Link>
                    <Link to={`/productos`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-bullseye"></i>  Productos</Link>
                    <Link to={`/servicios`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-wrench"></i>  Servicios</Link>
                    <Link to={`/correos`} className="w3-bar-item w3-button w3-padding"><i className="far fa-envelope"></i> Correo</Link>
                    <Link to={`/config`} className="w3-bar-item w3-button w3-padding"><i className="fas fa-cog"></i>  Ajustes</Link><br /><br />
            </div>
        </nav>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/Sidebar/Sidebar.js